import {EnrollmentReasonValidateParam, validateAddressBuilding, validateAddressCity, validateAddressPrefectureCode, validateAddressStreet, validateAgreeCheck, validateEnrollmentReason, validatePhoneMobile, validatePhoneTel, validatePostCode} from './MembersValidation'
import {validateConvenienceStore, validateCreditCardExpireMonth, validateCreditCardExpireYear, validateCreditCardHolderName, validateCreditCardNumber, validateCreditCardSecurityCode, validateCreditCardType, validateFutureExpireDate, validateMobileCarrier, validateMyCreditCardSecurityCode, validatePaymentInputMethod, validatePaymentInputTerm} from './PaymentInputInfoValidation'
import {ContractMethod, ContractTerm, CreditCardType, MobileCarrierKey} from '../../Props/ContractInputInfo'
import {Optional} from '../../../Common/TypeHelper'

export type ValidationJoinInput = {
  agreedIdList: number[]
  postCode: string
  addressPrefectureCode: string
  addressCity: string
  addressStreet: string
  addressBuilding: string
  phoneMobile: string
  phoneTel: string
  paymentInputTerm: ContractTerm
  paymentInputMethod: Optional<ContractMethod>
  creditCardType: CreditCardType
  creditCardNumber: string
  creditCardExpireMonth: string
  creditCardExpireYear: string
  creditCardHolderName: string
  creditCardSecurityCode: string
  myCreditCardSecurityCode: string
  convenienceStore: string
  mobileCarrier: MobileCarrierKey
  enrollmentReasonValidateParam: EnrollmentReasonValidateParam
}

type CombinationResult = {
  creditCardFutureExpireDate: string[]
}

export type ValidationJoinResultDetail = {
  [K in keyof ValidationJoinInput]: string[]
} & CombinationResult

export type ValidationJoinResult = {
  hasError: boolean
  errors: ValidationJoinResultDetail
}

export const validateMemberJoinInput = (
  input: ValidationJoinInput,
): ValidationJoinResult => {

  const details: ValidationJoinResultDetail = {
    agreedIdList: validateAgreeCheck(input.agreedIdList),
    postCode: validatePostCode(input.postCode),
    addressPrefectureCode: validateAddressPrefectureCode(input.addressPrefectureCode),
    addressCity: validateAddressCity(input.addressCity),
    addressStreet: validateAddressStreet(input.addressStreet),
    addressBuilding: validateAddressBuilding(input.addressBuilding),
    phoneMobile: validatePhoneMobile(input.phoneMobile),
    phoneTel: validatePhoneTel(input.phoneTel),
    paymentInputTerm: validatePaymentInputTerm(input.paymentInputTerm),
    paymentInputMethod:
      validatePaymentInputMethod(input.paymentInputMethod),
    creditCardType: validateCreditCardType(input.paymentInputMethod, input.creditCardType),
    creditCardNumber: validateCreditCardNumber(
      input.paymentInputMethod, input.creditCardType, input.creditCardNumber),
    creditCardExpireMonth: validateCreditCardExpireMonth(
      input.paymentInputMethod, input.creditCardType, input.creditCardExpireMonth),
    creditCardExpireYear: validateCreditCardExpireYear(
      input.paymentInputMethod, input.creditCardType, input.creditCardExpireYear),
    creditCardFutureExpireDate: validateFutureExpireDate(
      input.paymentInputMethod,
      input.creditCardType,
      input.creditCardExpireMonth,
      input.creditCardExpireYear,
    ),
    creditCardHolderName: validateCreditCardHolderName(
      input.paymentInputMethod, input.creditCardType, input.creditCardHolderName),
    creditCardSecurityCode: validateCreditCardSecurityCode(
      input.paymentInputMethod, input.creditCardType, input.creditCardSecurityCode),
    myCreditCardSecurityCode: validateMyCreditCardSecurityCode(
      input.paymentInputMethod, input.creditCardType, input.myCreditCardSecurityCode),
    convenienceStore: validateConvenienceStore(input.paymentInputMethod, input.convenienceStore),
    mobileCarrier: validateMobileCarrier(input.paymentInputMethod, input.mobileCarrier),
    enrollmentReasonValidateParam: validateEnrollmentReason(input.enrollmentReasonValidateParam),
  }

  const hasError =
    Object.values(details)
      .map(errorArray => errorArray.length)
      .some(length => length > 0)

  return {
    hasError: hasError,
    errors: details,
  }
}
